/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Message_PlaceholderInputs */

const en_carrier_notices_message_placeholder = /** @type {(inputs: Carrier_Notices_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the customer-facing carrier warning...`)
};

const es_carrier_notices_message_placeholder = /** @type {(inputs: Carrier_Notices_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa la advertencia para el cliente...`)
};

/**
* | output |
* | --- |
* | "Enter the customer-facing carrier warning..." |
*
* @param {Carrier_Notices_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_message_placeholder = /** @type {((inputs?: Carrier_Notices_Message_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Message_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_message_placeholder(inputs)
	return es_carrier_notices_message_placeholder(inputs)
});